import { render, staticRenderFns } from "./AdvancedTables.vue?vue&type=template&id=12157104"
import script from "./AdvancedTables.vue?vue&type=script&lang=js"
export * from "./AdvancedTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports